<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12">
        <v-row class="title">
          <v-col cols="12">
            <h2>Broadcast</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <p class="sub-head">เป้าหมายโดยประมาณ</p>
            <p style="font-size: 12px; color: #2e263d" class="set-margin0">
              ตัวเลขที่แสดงเป็นค่าโดยประมาณจึงอาจแตกต่างจากจำนวนที่บรอดแคสต์จริง
            </p>

            <div class="cycle">
              <v-progress-circular
                :rotate="180"
                :size="180"
                :width="25"
                :value="targetPercent"
                color="#16B1FF"
              >
                {{ lengthMember.toLocaleString() }} /
                {{ allMember.toLocaleString() }} คน
              </v-progress-circular>
            </div>
            <p
              style="font-size: 12px; color: #2e263d"
              class="set-margin0 text-center"
            >
              <span v-if="excludedCount > 0">
                ไม่นับ {{ excludedCount.toLocaleString() }} คนที่ไม่รับข่าวสาร
              </span>
            </p>
            <div>
              <v-row>
                <v-col>
                  <p class="sub-head">Filter</p>
                </v-col>
                <v-col class="text-right">
                  <v-btn small color="error" @click="clear()">ล้าง</v-btn>
                  <v-btn
                    small
                    color="success"
                    @click="dataMember(), (selected = []), (lengthMember = 0)"
                    >ค้นหา</v-btn
                  >
                </v-col>
              </v-row>

              <v-row align="center" class="no-padding-bottom">
                <v-col v-if="useSalesFilter" cols="12" class="setPadding">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeText"
                        label="วันที่ใช้บริการ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="clearTextField()"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="setPadding">
                  <v-range-slider
                    v-model="scoreRange"
                    :max="max"
                    :min="min"
                    hide-details
                    class="align-center"
                  >
                    <template v-slot:prepend>
                      <!-- {{ scoreRange }} -->
                      <v-text-field
                        v-model="scoreRange[0]"
                        label="ช่วงคะแนน"
                        hide-details
                        type="number"
                        outlined
                        dense
                        style="width: 80px"
                        @change="$set(scoreRange, 0, $event)"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        label="ช่วงคะแนน"
                        v-model="scoreRange[1]"
                        hide-details
                        type="number"
                        outlined
                        dense
                        style="width: 80px"
                        @change="$set(scoreRange, 1, $event)"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
              </v-row>
              <v-row align="center" class="no-padding-bottom">
                <v-col cols="12" class="setPadding">
                  <v-range-slider
                    v-model="age"
                    :max="maxA"
                    :min="min"
                    hide-details
                    class="align-center"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        label="ช่วงอายุ"
                        v-model="age[0]"
                        hide-details
                        type="number"
                        outlined
                        dense
                        style="width: 80px"
                        @change="$set(age, 0, $event)"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        label="ช่วงอายุ"
                        v-model="age[1]"
                        hide-details
                        type="number"
                        outlined
                        dense
                        style="width: 80px"
                        @change="$set(age, 1, $event)"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectLevel"
                    placeholder="ระดับสมาชิก"
                    label="ระดับสมาชิก"
                    :items="dataLevel"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                    class="custom-blue-background"
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectLevel.length > 1">, ...</span></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectGender"
                    placeholder="เพศ"
                    label="เพศ"
                    :items="dataGender"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectGender.length > 1"
                          >, ...</span
                        ></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectItemGroup"
                    placeholder="บริการที่ใช้ล่าสุด"
                    label="บริการที่ใช้ล่าสุด"
                    :items="dataItemGroup"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectItemGroup.length > 1"
                          >, ...</span
                        ></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectBranch"
                    placeholder="สาขา"
                    label="สาขา"
                    :items="dataBranch"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectBranch.length > 1"
                          >, ...</span
                        ></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectBrand"
                    placeholder="แบรนด์"
                    label="แบรนด์"
                    :items="dataBrand"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectBrand.length > 1">, ...</span></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectCategoryType"
                    placeholder="ประเภทสินค้า"
                    label="ประเภทสินค้า"
                    :items="dataCategoryType"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectCategoryType.length > 1"
                          >, ...</span
                        ></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectChannel"
                    placeholder="ช่องทางการขาย"
                    label="ช่องทางการขาย"
                    :items="dataChannel"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                    ><template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectChannel.length > 1"
                          >, ...</span
                        ></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="useSalesFilter" cols="6" class="setPadding">
                  <v-autocomplete
                    v-model="selectModel"
                    placeholder="โมเดล"
                    label="โมเดล"
                    :items="dataModel"
                    outlined
                    dense
                    hide-details
                    clearable
                    multiple
                    item-text="text"
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0"
                        >{{ item.text
                        }}<span v-if="selectModel.length > 1">, ...</span></span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <div class="line col-1">
            <v-divider vertical></v-divider>
          </div>
          <v-col cols="6" class="pl-0">
            <div class="d-flex justify-center align-center flex-wrap">
              <p class="sub-head pr-5">รายชื่อลูกค้า</p>
              <v-text-field
                v-model="search"
                label=""
                placeholder="Search"
                outlined
                dense
                hide-details
                class="pr-2"
                @keyup="filteredRowCount"
                style="flex: 1"
              ></v-text-field>
              <!-- <div class="pr-2">
                <v-btn color="#386CB9" dark @click="dialog = true"
                  >import <v-icon>mdi-arrow-collapse-down</v-icon></v-btn
                >
              </div>
              <download-excel
                ref="downloadExcel"
                :data="export_datas"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
                style="display: none"
              ></download-excel>

              <v-btn color="#259D5B" dark @click="downloadTemplate">
                template <v-icon>mdi-file-excel</v-icon>
              </v-btn> -->
            </div>
            <div style="padding-top: 15px">
              <!-- {{ selected.length }} -->

              <v-data-table
                v-model="selected"
                ref="dataTable"
                :headers="headers"
                :items="filteredDesserts"
                :single-select="singleSelect"
                item-key="memberId"
                show-select
                @toggle-select-all="selectAllToggle"
                :items-per-page.sync="itemsPerPage"
                :page.sync="page"
                :footer-props="footerProps"
                :loading="loadingMember"
                loading-text="กำลังโหลดรายชื่อลูกค้า..."
                height="650"
              >
                <template
                  v-slot:item.data-table-select="{ item, isSelected, select }"
                >
                  <v-simple-checkbox
                    :value="isSelected"
                    :readonly="item.disabled"
                    :disabled="item.disabled"
                    @input="
                      () => {
                        select();
                        toggleItemSelection(item);
                      }
                    "
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.gender="{ item }">
                  <v-chip
                    :color="getColorGender(item.gender)"
                    dark
                    style="
                      width: 55px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    {{ item.gender }}
                  </v-chip>
                </template>
                <template v-slot:item.LevelName="{ item }">
                  <v-chip
                    :color="getColorLevel(item)"
                    dark
                    style="
                      min-width: 75px;
                      display: inline-flex;
                      justify-content: center;
                      align-items: center;
                      white-space: nowrap;
                    "
                  >
                    {{ item.LevelName }}
                  </v-chip>
                </template>
                <template v-slot:item.CONDITION_TERM2="{ item }">
                  <p
                    :style="{
                      color:
                        item.CONDITION_TERM2 === 'ไม่รับข่าวสาร' ? 'red' : null,
                    }"
                  >
                    {{ item.CONDITION_TERM2 }}
                  </p>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
        <v-row> </v-row>

        <v-row>
          <v-col>
            <div
              style="
                border-style: solid;
                border-radius: 6px;
                border-color: #2e263d29;
              "
            >
              <div
                style="
                  display: flex;
                  padding: 10px 15px;
                  gap: 8px; /* เพิ่มระยะห่างระหว่างปุ่มทั้งหมดเป็น 8px */
                "
              >
                <v-btn
                  depressed
                  color="white"
                  width="150"
                  @click="clearContent(), setActive('text')"
                  :class="{ active: selectType === 'text' }"
                >
                  <v-icon
                    :style="{
                      color: selectType === 'text' ? '#35495e' : '#8e9494',
                      paddingRight: '3px',
                    }"
                    class="mdi-22"
                    >mdi-message-processing</v-icon
                  >
                  ข้อความ
                </v-btn>
                <v-btn
                  depressed
                  color="white"
                  width="150"
                  @click="clearContent(), setActive('img')"
                  :class="{ active: selectType === 'img' }"
                >
                  <v-icon
                    :style="{
                      color: selectType === 'img' ? '#35495e' : '#8e9494',
                    }"
                    >mdi-image</v-icon
                  >รูปภาพ
                </v-btn>
                <v-btn
                  depressed
                  color="white"
                  width="150"
                  @click="clearContent(), setActive('reward')"
                  :class="{ active: selectType === 'reward' }"
                >
                  <v-icon
                    :style="{
                      color: selectType === 'reward' ? '#35495e' : '#8e9494',
                    }"
                    >mdi-gift</v-icon
                  >ของรางวัล
                </v-btn>
                <v-btn
                  depressed
                  color="white"
                  width="150"
                  @click="clearContent(), setActive('activity')"
                  :class="{ active: selectType === 'activity' }"
                >
                  <v-icon
                    :style="{
                      color: selectType === 'activity' ? '#35495e' : '#8e9494',
                    }"
                    >mdi-star</v-icon
                  >กิจกรรม
                </v-btn>
                <v-btn
                  depressed
                  color="white"
                  width="150"
                  @click="clearContent(), setActive('video')"
                  :class="{ active: selectType === 'video' }"
                >
                  <v-icon
                    :style="{
                      color: selectType === 'video' ? '#35495e' : '#8e9494',
                    }"
                    >mdi-video</v-icon
                  >วิดีโอ
                </v-btn>
              </div>
              <div style="padding: 10px 15px" v-if="selectType === 'text'">
                <v-textarea
                  v-model="message"
                  row-height="35"
                  rows="5"
                  counter
                  maxlength="5000"
                  outlined
                  auto-grow
                  placeholder="Write your message..."
                  class="custom-counter"
                ></v-textarea>
              </div>
              <div
                class="img"
                v-if="selectType === 'img'"
                style="
                  height: 250px;
                  border: 2px dashed gray;
                  margin: 10px 15px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  cursor: pointer;
                "
                @click="triggerUpload"
              >
                <div v-if="!img">
                  <div class="d-flex justify-center">
                    <v-icon style="font-size: 80px">mdi-image</v-icon>
                  </div>

                  <p>Upload Photo</p>
                </div>

                <div v-if="img" @click.stop="triggerUpload">
                  <div class="d-flex justify-center">
                    <v-img :src="img" width="200" height="200" contain></v-img>
                  </div>
                  <p>{{ img }}</p>
                </div>

                <input
                  style="display: none"
                  ref="uploadImage"
                  type="file"
                  accept="image/png, image/jpeg,  image/jpg"
                  @change="onSelectFile"
                />
                <!-- hange="onSelectFile" /> -->
              </div>
              <p
                v-if="selectType === 'img'"
                style="margin: 0px 15px; font-size: small; color: #adb5bd"
              >
                รูปแบบไฟล์: JPG, JPEG, PNG
              </p>
              <p
                v-if="selectType === 'img'"
                style="margin: 0px 15px; font-size: small; color: #adb5bd"
              >
                ขนาดไฟล์: ไม่เกิน 10 MB
              </p>

              <div
                class="reward"
                v-if="selectType === 'reward'"
                style="height: 650px; margin: 10px 15px"
              >
                <v-row>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                  <v-sheet max-width="100%" style="background-color: ;">
  <v-slide-group
    v-model="model"
    class="pa-4"
    center-active
    show-arrows
  >
    <v-slide-item
      v-for="n in dataReward"
      :key="n"
      v-slot="{ active, toggle }"
    >
      <v-card
        :style="{
          borderRadius: '8px',
          border: active ? '2px solid #16B1FF !important' : '2px solid transparent'
        }"
        class="ma-3"
        height="310"
        width="220"
        @click="
          () => {
            toggle();
            selectItem(n);
          }
        "
      >
        <v-responsive>
          <v-img
            height="200"
            width="200"
            contain
            :src="n.pictureUrl"
          ></v-img>
        </v-responsive>
        <!-- Additional content inside v-card -->
        <div style="padding: 0 12px">
                              <h3
                                class="text-ellipsis"
                                style="font-size: 16px !important"
                              >
                                {{ n.name }}
                              </h3>
                              <v-row>
                                <v-col style="padding: 12px 15px 0">
                                  <p
                                    class="text-ellipsis"
                                    style="
                                      margin: 0;
                                      font-size: 14px !important;
                                    "
                                  >
                                    คงเหลือ:
                                  </p>
                                </v-col>
                                <v-col
                                  class="text-right"
                                  style="padding: 12px 15px 0"
                                >
                                  <p
                                    class="text-ellipsis"
                                    style="
                                      margin: 0;
                                      font-size: 14px !important;
                                    "
                                  >
                                    {{ n.quotaCode }} ชิ้น
                                  </p>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col style="padding: 2px 15px 0">
                                  <p
                                    class="text-ellipsis"
                                    style="
                                      margin: 0;
                                      font-size: 14px !important;
                                    "
                                  >
                                    ใช้แลกคะแนน:
                                  </p>
                                </v-col>
                                <v-col
                                  class="text-right"
                                  style="padding: 2px 15px 0"
                                >
                                  <p
                                    class="text-ellipsis"
                                    style="
                                      margin: 0;
                                      font-size: 14px !important;
                                    "
                                  >
                                    {{ n.point }} คะแนน
                                  </p>
                                </v-col>
                              </v-row>
                            </div>
      </v-card>
    </v-slide-item>
  </v-slide-group>
</v-sheet>

                    <!-- <v-sheet class="" max-width="100%" style="background-color:red">
                      <v-slide-group
                        v-model="model"
                        class="pa-4"
                        center-active
                        show-arrows
                      >
                        <v-slide-item
                          v-for="n in dataReward"
                          :key="n"
                          v-slot="{ active, toggle }"
                        >
                          <v-card
                            :style="{
                              borderRadius: '8px',
                              border: active
                                ? '2px solid #16B1FF !important'
                                : '2px solid transparent',
                            }"
                            class="ma-3"
                            height="310"
                            width="220"
                            @click="
                              () => {
                                toggle();
                                selectItem(n);
                              }
                            "
                          >
                            <div style="padding: 12px">
                              <v-img
                                height="200"
                                width="200"
                                contain
                                :src="n.pictureUrl"
                              ></v-img>
                            </div>
                          </v-card>
                        </v-slide-item>
                      </v-slide-group>
                    </v-sheet> -->
                  </div>
                </v-row>

                <v-row>
                  <v-col>
                    <p>หมายเหตุ</p>
                    <v-textarea
                      v-model="noteReward"
                      row-height="35"
                      rows="5"
                      counter
                      maxlength="5000"
                      outlined
                      auto-grow
                      placeholder="Write your message..."
                      class="custom-counter"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <div v-if="selectType === 'activity'" style="padding: 10px">
                <div style="max-height: 250px; overflow-y: auto">
                  <v-radio-group v-model="radioGroup" class="radio-group">
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        flex-direction: column;
                        gap: 10px;
                      "
                    >
                      <v-radio
                        v-for="n in itemsActivity"
                        :key="n.activityId"
                        :label="` ${n.title}`"
                        :value="n"
                        style="
                          border: 1px solid black;
                          height: 50px;
                          border-radius: 8px;
                        "
                        @click="selectActivity(n)"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </div>
                <v-row>
                  <v-col>
                    <p>หมายเหตุ</p>
                    <v-textarea
                      v-model="noteAct"
                      row-height="35"
                      rows="5"
                      counter
                      maxlength="5000"
                      outlined
                      auto-grow
                      placeholder="Write your message..."
                      class="custom-counter"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <div style="padding: 10px 15px" v-if="selectType === 'video'">
                <v-row>
                  <v-col>
                    <p>วิดีโอ</p>
                    <div
                      style="
                        height: 250px;
                        border: 2px dashed gray;
                        margin: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                      "
                      @click="uploadVideo"
                    >
                      <div v-if="!vdo" style="b">
                        <div class="d-flex justify-center">
                          <v-icon style="font-size: 80px">mdi-video</v-icon>
                        </div>
                        <p>Upload Video</p>
                      </div>
                      <div v-if="vdo" class="d-flex justify-center">
                        <video width="200" height="200" controls>
                          <source :src="vdo" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <input
                        type="file"
                        ref="uploadVideo"
                        style="display: none"
                        @change="onSelectFileVideo"
                        accept=".mp4,.m4v,.mov,.avi,.wmv"
                      />
                    </div>
                    <p
                      v-if="selectType === 'video'"
                      style="margin: 0px ; font-size: small; color: #adb5bd"
                    >
                    รูปแบบไฟล์: MP4, M4V, MOV, AVI, WMV
                    </p>
                    <p
                      v-if="selectType === 'video'"
                      style="margin: 0px ; font-size: small; color: #adb5bd"
                    >
                    ขนาดไฟล์: ไม่เกิน 200 MB
                    </p>
                  </v-col>

                  <v-col>
                    <p>ภาพหน้าปก</p>
                    <div
                      style="
                        height: 250px;
                        width: 100%;
                        border: 2px dashed gray;
                        margin: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                      "
                      @click="uploadCover"
                    >
                      <div v-if="!covers">
                        <div class="d-flex justify-center">
                          <v-icon style="font-size: 80px"
                            >mdi-image-area</v-icon
                          >
                        </div>

                        <p>Upload cover</p>
                      </div>
                      <div v-if="covers" @click.stop="uploadCover">
                        <div class="d-flex justify-center">
                          <v-img
                            :src="covers"
                            width="200"
                            height="200"
                            contain
                          ></v-img>
                        </div>
                      </div>
                      <input
                        style="display: none"
                        ref="uploadCover"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        @change="onSelectFileCover"
                      />
                    </div>
                    <p
                      v-if="selectType === 'video'"
                      style="margin: 0px; font-size: small; color: #adb5bd"
                    >
                      รูปแบบไฟล์: JPG, JPEG, PNG
                    </p>
                    <p
                      v-if="selectType === 'video'"
                      style="margin: 0px; font-size: small; color: #adb5bd"
                    >
                      ขนาดไฟล์: ไม่เกิน 10 MB
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>หมายเหตุ</p>
                    <v-textarea
                      v-model="note"
                      row-height="35"
                      rows="5"
                      counter
                      maxlength="5000"
                      outlined
                      auto-grow
                      placeholder="Write your message..."
                      class="custom-counter"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <div style="" class="text-right pa-2">
                <v-btn
                  color="success"
                  class="broadcast-btn"
                  :loading="sentLoad"
                  @click="sentBroadcast"
                >
                  บรอดแคสต์
                  <template v-slot:loader>
                    <span
                      class="broadcast-btn__fill"
                      :style="{ width: sendPct + '%' }"
                    ></span>
                    <span class="broadcast-btn__loader">
                      <v-progress-circular
                        :value="sendPct"
                        :indeterminate="sendPct <= 0"
                        :size="20"
                        :width="2"
                        color="white"
                      ></v-progress-circular>
                    </span>
                  </template>
                </v-btn>
              </div>
              <div>
                <v-dialog v-model="dialog" persistent max-width="40%">
                  <v-card style="padding: 15px">
                    <v-card-title>
                      <span class="headline">จัดการไฟล์ผ่าน excel.xls</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <!-- เอา @change ออก -->
                            <input
                              type="file"
                              ref="fileInput"
                              accept=".xls, .xlsx"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" @click="dialog = false"> ปิด </v-btn>
                      <!-- เปลี่ยนให้กดปุ่มนี้ทำงาน importData -->
                      <v-btn color="success" @click="uploadFile">
                        อัปโหลด
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx

const CHANNEL_NO_BILL = '__NO_BILL__'
const CHANNEL_OTHER = '__OTHER__'
const NOT_SELL_KEYS = ['shopId', 'levelId', 'gender', 'currentPoint', 'age']
// import readXlsxFile from 'read-excel-file'
export default {
  components: {
    downloadExcel: JsonExcel
  },
  name: 'LoyaltyProdBroadCast',
  data () {
    return {
      min: 0,
      max: 0,
      minA: 0,
      maxA: 0,
      exportType: 'xls',
      exportFileName: 'liffUserId.xls',
      exportWorksheet: 'WorkSheet',
      export_datas: [
        {
          uid: ''
        }
      ],
      sentLoad: false,
      sendPct: 0,
      sendTimer: null,
      sendBroadcastId: null,
      sendStartedTs: 0,
      search: '',
      filesAdd: null,
      dataLevel: [],
      dataGender: [],
      dataItemGroup: [],
      dataBranch: [],
      dataBrand: [],
      dataModel: [],
      dataCategoryType: [],
      dataChannel: [],
      selectLevel: [],
      selectGender: [],
      selectItemGroup: [],
      selectBranch: [],
      selectBrand: [],
      selectModel: [],
      selectCategoryType: [],
      selectChannel: [],
      selectType: 'text',
      selected: [],
      resendRecipientIds: null,
      resendApplied: false,
      disabledCount: 0,
      headers: [
        { text: 'ชื่อ', value: 'nameCustomer' },
        { text: 'ระดับสมาชิก', value: 'LevelName' },
        { text: 'เพศ', value: 'gender', align: 'center' },
        { text: 'อายุ', value: 'age' },
        { text: 'คะแนน', value: 'currentPoint' },
        // { text: 'บริการล่าสุด', value: 'ItemGroup' },
        { text: 'ข่าวสาร', value: 'CONDITION_TERM2' }
      ],
      desserts: [],
      session: this.$session.getAll(),
      minScore: '',
      maxScore: '',
      minScoreAge: '',
      maxScoreAge: '',
      scoreRange: [0, 0],
      age: [0, 0],
      selectedItems: [],
      data: [],
      menu: false,
      date: [],
      lengthMember: 0,
      newGender: '',
      dataReward: [],
      itemsActivity: [],
      vdo: null,
      videoURL: '',
      preImg: null,
      note: '',
      noteReward: '',
      noteAct: '',
      message: '',
      img: null,
      selectedRadioA: null,
      covers: null,
      fileImg: null,
      fileCovers: null,
      fileVDO: null,
      rewardImg: '',
      rewardPoint: '',
      rewardName: '',
      rewardId: '',
      acImg: '',
      acName: '',
      dialog: false,
      memberNotSell: [],
      loadingMember: false,
      memberSell: [],
      // จำนวนในลิสต์ ณ ตอนนี้ = ตัวหารของโดนัท ตรงกับตัวเลขท้ายตาราง
      allMember: 0,
      singleSelect: false,
      // แบ่งหน้าจริง แทนการเลื่อนแล้วต่อท้ายทีละ 100 แถว
      itemsPerPage: 50,
      page: 1,
      footerProps: {
        'items-per-page-options': [25, 50, 100, 200],
        'items-per-page-text': 'แถวต่อหน้า',
        'show-current-page': true,
        'show-first-last-page': true
      },
      filteredItemsCount: 0,
      selectedCard: null,
      rules: [
        value => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!'
      ]

    }
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property

    areAllItemsSelected () {
      const selectableItems = this.desserts.filter((item) => !item.disabled)
      return (
        selectableItems.length > 0 &&
        this.selected.length === selectableItems.length
      )
    },
    dateRangeText () {
      return this.date.join(' - ')
    },
    // ตัวกรองฝั่งการขาย (วันที่ใช้บริการ/สาขา/แบรนด์/ประเภทสินค้า/ช่องทางการขาย/
    // โมเดล) มีข้อมูลรองรับเฉพาะร้าน BPV ร้านอื่นต้องไม่เห็น และต้องไม่ถูกส่งไป
    // ค้นด้วย endpoint ฝั่งการขายด้วย
    //
    // ของเดิม shopNameData.SHOP_ID_BPV ไม่มีอยู่จริงใน main.js (มีแต่ CHUBB)
    // ช่องแรกของ list จึงเป็น undefined พอร้านไหน session ไม่มี shopId
    // indexOf(undefined) เจอที่ช่อง 0 เลยคืน true ร้านนั้นได้ตัวกรอง BPV ไปด้วย
    useSalesFilter () {
      const session = this.$session.getAll() || {}
      const shopId = (session.data && session.data.shopId) || ''
      const bpvShopIds = [
        this.shopNameData.SHOP_ID_BPV,
        'U091c88a8550f2296a2663964ba7c9845',
        'U4e23f7bf31b362622ff7c5c06dfdf350',
        'U368b12c1406c22b6d6156d8b096db5ab'
      ].filter(Boolean)
      return shopId !== '' && bpvShopIds.indexOf(shopId) !== -1
    },
    // คนที่อยู่ในลิสต์และยังรับข่าวสาร = ที่ติ๊กให้อัตโนมัติทุกครั้งที่ดึงข้อมูล
    targetCount () {
      return this.filteredDesserts.filter((item) => !item.disabled).length
    },
    excludedCount () {
      return this.allMember - this.targetCount
    },
    targetPercent () {
      const total = this.allMember
      if (!total) {
        return 0
      }
      const percent = (this.lengthMember * 100) / total
      return isNaN(percent) ? 0 : percent
    },
    filteredDesserts () {
      const q = String(this.search || '').toLocaleLowerCase()
      if (!q) {
        return this.desserts
      }
      const keys = this.headers.map((h) => h.value).filter((v) => v)
      return this.desserts.filter((item) =>
        keys.some((k) => {
          const v = item[k]
          return (
            v !== null &&
            v !== undefined &&
            typeof v !== 'boolean' &&
            String(v).toLocaleLowerCase().indexOf(q) !== -1
          )
        })
      )
    }
  },
  beforeDestroy () {
    this.stopSendProgress()
  },
  watch: {
    desserts () {
      this.applyResendSelection()
    },
    filteredDesserts () {
      this.allMember = this.filteredDesserts.length
      // ผลลัพธ์ชุดใหม่ ให้กลับไปหน้าแรก ไม่ค้างอยู่หน้าที่ไม่มีข้อมูลแล้ว
      this.page = 1
    }
  },
  async mounted () {
    this.filteredRowCount()
    await this.getLevel()
    await this.countDataDisable()
    if (this.useSalesFilter) {
      this.getdataFilter('BVP_MASTER_BRANCHCODE')
      this.getdataFilter('BVP_MASTER_CategoryType')
      this.getdataFilter('BVP_MASTER_CHANNEL')
      this.getdataFilter('BVP_MASTER_ItemGroup')
      this.getdataFilter('BVP_MASTER_BRANDCODE')
      this.getdataFilter('BVP_MASTER_MODEL')
    }
    this.getDataReward()
    this.getActivity()
    this.getMinMaxCurrentPoint()
    if (this.$route.query && this.$route.query.resendId) {
      this.prefillFromResend(this.$route.query.resendId)
    }
    this.getMember(true)
  },

  methods: {
    async prefillFromResend (id) {
      try {
        const res = await axios.get(this.DNS_IP + '/broadcast/getID?id=' + id)
        const b = res.data
        if (!b || b.status === false) {
          return
        }
        const mod = b.module
        this.selectType = mod === 'image' ? 'img' : mod === 'กิจกรรม' ? 'activity' : mod
        let recips = b.lineUserId
        if (typeof recips === 'string') {
          try {
            recips = JSON.parse(recips)
          } catch (e) {
            recips = []
          }
        }
        this.resendRecipientIds = new Set(
          (recips || []).map((r) => r.liffUserId || r.lineUserId).filter(Boolean)
        )
        this.resendApplied = false
        this.applyResendSelection()
        if (mod === 'text') {
          this.message = b.message || ''
        } else if (mod === 'image' || mod === 'img') {
          this.img = b.pictureUrl
        } else if (mod === 'reward') {
          this.rewardImg = b.pictureUrl
          const rw = (this.dataReward || []).find((x) => String(x.rewardId) === String(b.referId))
          if (rw) {
            this.selectItem(rw)
          }
        }
        this.$swal('ดึงข้อมูลเดิมมาให้แล้ว', `เลือกผู้รับเดิม ${this.resendRecipientIds.size} คนไว้ให้แล้ว กรุณาตรวจสอบและกรอก/เลือกข้อมูลที่ยังขาดให้ครบ แล้วกดส่ง`, 'info')
      } catch (e) {
        console.log('prefillFromResend error', e)
      }
    },
    applyResendSelection () {
      if (this.resendApplied) {
        return
      }
      if (!this.resendRecipientIds || this.resendRecipientIds.size === 0) {
        return
      }
      if (!this.desserts || this.desserts.length === 0) {
        return
      }
      const matched = this.desserts.filter((m) => this.resendRecipientIds.has(m.liffUserId))
      if (matched.length === 0) {
        return
      }
      this.selected = matched
      this.lengthMember = matched.length
      this.resendApplied = true
    },
    async getMinMaxCurrentPoint () {
      const shopId = this.$session.getAll().data.shopId
      try {
        const res = await axios.get(
          this.DNS_IP + '/memberCard/stats?shopId=' + shopId
        )
        if (res.data && res.data.status === true) {
          this.applyMemberCardStats(
            res.data.maxPoint,
            res.data.maxAge,
            res.data.genders || []
          )
          return
        }
      } catch (error) {
        console.error('memberCard/stats unavailable, falling back:', error)
      }
      await axios
        .get(
          this.DNS_IP + '/memberCard/get?shopId=' + shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            // ค่าเป็น0
          } else {
            this.applyMemberCardStats(
              Math.max(...res.data.map((item) => item.currentPoint)),
              Math.max(...res.data.map((item) => item.age)),
              res.data.map((item) => item.gender)
            )
          }
        })
    },
    applyMemberCardStats (maxPoint, maxAge, genders) {
      genders.forEach((g) => this.addGenderOption(g))
      this.max = maxPoint
      this.scoreRange = [this.minScore, this.maxScore]
      this.age = [this.minScoreAge, this.maxScoreAge]
      this.maxA = maxAge
    },
    filteredRowCount () {
      this.allMember = this.filteredDesserts.length
    },
    addGenderOption (gender) {
      if (!gender) {
        return
      }
      if (this.dataGender.some((g) => g.value === gender)) {
        return
      }
      const text =
        gender === 'male' ? 'ชาย' : gender === 'female' ? 'หญิง' : 'ไม่ระบุ'
      this.dataGender.push({ text, value: gender })
    },
    downloadTemplate () {
      this.$refs.downloadExcel.$el.click() // เรียกใช้การดาวน์โหลด
    },
    selectActivity (n) {
      // console.log(n)
      this.acImg = n.pictureUrl
      this.acName = n.title
    },
    selectItem (n) {
      // console.log('nnn', n)
      this.rewardImg = n.pictureUrl
      this.rewardPoint = n.point
      this.rewardName = n.name
      this.rewardId = n.rewardId
    },
    onSelectFile (event) {
      this.fileImg = event.target.files[0]
      const file = event.target.files[0]
      if (file) {
        // ดำเนินการกับไฟล์ที่เลือก
        // console.log(file) // ตัวอย่างการใช้งานไฟล์ที่อัปโหลด
        this.img = URL.createObjectURL(file) // ใช้ไฟล์เองแทนการใช้ file.name
      }
    },
    triggerUpload () {
      this.$refs.uploadImage.click() // เรียกใช้งาน input ที่ซ่อนอยู่
    },
    uploadVideo () {
      this.$refs.uploadVideo.click()
    },
    onSelectFileVideo (event) {
      this.fileVDO = event.target.files[0]
      const filevdo = event.target.files[0]
      if (filevdo) {
        // console.log(filevdo) // ตัวอย่างการใช้งานไฟล์ที่อัปโหลด
        this.vdo = URL.createObjectURL(filevdo) // สร้าง URL สำหรับไฟล์
      }
    },
    uploadCover () {
      this.$refs.uploadCover.click()
    },
    onSelectFileCover (event) {
      this.fileCovers = event.target.files[0]
      const file = event.target.files[0]
      if (file) {
        // console.log(file) // ตัวอย่างการใช้งานไฟล์ที่อัปโหลด
        this.covers = URL.createObjectURL(file) // ใช้ไฟล์เองแทนการใช้ file.name
      }
    },
    setActive (type) {
      this.selectType = type // กำหนดสถานะของปุ่มที่ถูกเลือก
    },
    updateRange () {
      this.scoreRange = [this.minScore, this.maxScore]
    },
    getdataFilter (param) {
      axios
        .get(this.DNS_IP + '/hitorysell/get-filter?type=' + param)
        .then((res) => {
          if (param === 'BVP_MASTER_BRANCHCODE') {
            if (res.data.status === false) {
              this.dataBranch = []
            } else {
              // console.log('res.data', res.data)

              res.data.map((el) => {
                if (el.Text) {
                  let b = {
                    text: el.Text,
                    value: el.Text
                  }
                  this.dataBranch.push(b)
                }
              })
            }
          } else if (param === 'BVP_MASTER_CategoryType') {
            if (res.data.status === false) {
              this.dataCategoryType = []
            } else {
              res.data.map((el) => {
                if (el.Text) {
                  let c = {
                    text: el.Text,
                    value: el.Text
                  }
                  this.dataCategoryType.push(c)
                }
              })
            }
          } else if (param === 'BVP_MASTER_CHANNEL') {
            if (res.data.status === false) {
              this.dataChannel = []
            } else {
              res.data.map((el) => {
                if (el.Text) {
                  let ch = {
                    text: el.Text,
                    value: el.Text
                  }
                  this.dataChannel.push(ch)
                }
              })
            }
            this.dataChannel.push(
              { text: 'Retail (ไม่มีบิล)', value: CHANNEL_NO_BILL },
              { text: 'อื่นๆ', value: CHANNEL_OTHER }
            )
          } else if (param === 'BVP_MASTER_ItemGroup') {
            if (res.data.status === false) {
              this.dataItemGroup = []
            } else {
              res.data.map((el) => {
                if (el.Text) {
                  let i = {
                    text: el.Text,
                    value: el.Text
                  }
                  this.dataItemGroup.push(i)
                }
              })
            }
          } else if (param === 'BVP_MASTER_BRANDCODE') {
            if (res.data.status === false) {
              this.dataBrand = []
            } else {
              res.data.map((el) => {
                if (el.Text) {
                  let br = {
                    text: el.Text,
                    value: el.Text
                  }
                  this.dataBrand.push(br)
                }
              })
            }
          } else if (param === 'BVP_MASTER_MODEL') {
            // console.log('res.data111', res.data)

            if (res.data.status === false) {
              this.dataModel = []
            } else {
              // console.log('dddd', res.data)

              res.data.map((el) => {
                // console.log('elll', el)

                if (el.text) {
                  let m = {
                    text: el.text,
                    value: el.text
                  }
                  // console.log('mmmmm', m)

                  this.dataModel.push(m)
                }
              })
              // console.log('res.data111', this.dataModel)
            }
          }
        })
    },
    async dataMember (ignoreFilter) {
      if (!this.useSalesFilter) {
        await this.getMember(ignoreFilter)
        return
      }
      this.loadingMember = true
      try {
        let statusCon = true
        let wantNoBill = false
        let sql = {
          shopId: this.$session.getAll().data.shopId
        }
        this.disabledCount = 0

        if (!ignoreFilter) {
          if (this.date.length > 0) {
            if (this.date.length === 1) {
              this.date.push(this.date[0])
            } else if (this.date.length === 2) {
              this.date.sort((a, b) => new Date(a) - new Date(b))
            }
            sql.DOCDATE = this.date
            statusCon = false
            // console.log('1statusCon', statusCon, sql.DOCDATE)
          }

          // ตรวจสอบค่าที่เลือกและเพิ่มลงใน sql
          if (this.selectLevel) {
            sql.levelId = this.selectLevel
            if (this.selectLevel.length > 0) {
              // statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectGender) {
            sql.gender = this.selectGender
            if (this.selectGender.length > 0) {
              // statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectItemGroup) {
            sql.ItemGroup = this.selectItemGroup
            if (this.selectItemGroup.length > 0) {
              statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectBranch) {
            sql.BRANCHCODE = this.selectBranch
            if (this.selectBranch.length > 0) {
              statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectBrand) {
            sql.BRANDCODE = this.selectBrand
            if (this.selectBrand.length > 0) {
              statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectCategoryType) {
            sql.CategoryType = this.selectCategoryType
            if (this.selectCategoryType.length > 0) {
              statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          if (this.selectChannel && this.selectChannel.length > 0) {
            const channels = this.selectChannel.filter(
              (c) => c !== CHANNEL_NO_BILL && c !== CHANNEL_OTHER
            )
            wantNoBill = this.selectChannel.includes(CHANNEL_NO_BILL)
            if (channels.length > 0) {
              sql.CHANNEL = channels
              statusCon = false
            }
            if (this.selectChannel.includes(CHANNEL_OTHER)) {
              sql.CHANNEL_OTHER = this.dataChannel
                .map((c) => c.value)
                .filter((c) => c !== CHANNEL_NO_BILL && c !== CHANNEL_OTHER)
              statusCon = false
            }
          }
          if (this.selectModel) {
            sql.MODEL = this.selectModel
            if (this.selectModel.length > 0) {
              statusCon = false
              // console.log('2statusCon', statusCon, sql.levelId)
            }
          }
          // console.log('this.scoreRange', this.scoreRange)
          if (this.scoreRange) {
            sql.currentPoint = this.scoreRange
            // statusCon = false
            // console.log('aaaaaa')
          }
          if (this.age) {
            sql.age = this.age
            // statusCon = false
            // console.log('bbbb')
          }
        }

        // ลบ key ที่มีค่าเป็น undefined, null, หรือ ''
        Object.keys(sql).forEach((key) => {
          if (sql[key] === undefined || sql[key] === null || sql[key] === '') {
            delete sql[key]
          }
        })

        if (statusCon === true) {
          // alert('in')

          await axios
            .post(
              this.DNS_IP + '/hitoryNotSell/get-distinct',
              wantNoBill ? this.notSellSql(sql) : sql
            )
            .then(async (res) => {
              this.memberNotSell = []
              if (res.data.status === false) {
                this.memberNotSell = []
              } else {
                this.memberNotSell = res.data
              }
            })
          this.memberSell = []
          if (!wantNoBill) {
            await axios
              .post(this.DNS_IP + '/hitorysell/get-distinct', sql)
              .then(async (res) => {
                if (res.data.status === false) {
                  this.memberSell = []
                } else {
                  this.memberSell = res.data
                }
              })
          }
          // เอาmemberมารวมกัน
          // console.log('memberNotSell : ', this.memberNotSell)
          // console.log('memberSell : ', this.memberSell)
          const byMember = new Map()
          ;[...this.memberNotSell, ...this.memberSell].forEach((m) => {
            if (!byMember.has(m.memberId)) {
              byMember.set(m.memberId, m)
            }
          })
          this.desserts = Array.from(byMember.values())
          // this.desserts = this.memberNotSell.concat(this.memberSell)
          this.allMember = this.desserts.length
          const gender = { male: 'ชาย', female: 'หญิง' }
          let dataLevelss = {}
          this.dataLevel.map((el) => {
            dataLevelss[el.levelId] = el.name
          })
          // console.log('dataLevelss', dataLevelss)

          this.desserts.map((el) => {
            el.LevelName = dataLevelss[parseInt(el.levelId)] || 'ไม่ระบุ'
            // console.log('el.levelId', el.levelId)

            el.gender = gender[el.gender] || 'ไม่ระบุ'
            el.CONDITION_TERM2 =
              el.CONDITION_TERM2 === 'True' ? 'รับข่าวสาร' : 'ไม่รับข่าวสาร'
            el.disabled = el.CONDITION_TERM2 !== 'รับข่าวสาร'
            if (el.disabled) {
              this.disabledCount++
            }
            return el
          })
          this.autoSelectAll()
          this.loadingMember = false
        } else {
          // alert('false')

          // If statusCon is true, only the second Axios call is made
          axios
            .post(this.DNS_IP + '/hitorysell/get-distinct', sql)
            .then(async (res) => {
              let rows = res.data.status === false ? [] : res.data
              if (wantNoBill) {
                const notSell = await axios.post(
                  this.DNS_IP + '/hitoryNotSell/get-distinct',
                  this.notSellSql(sql)
                )
                if (notSell.data.status !== false) {
                  const seen = new Set(rows.map((m) => m.memberId))
                  notSell.data.forEach((m) => {
                    if (!seen.has(m.memberId)) {
                      seen.add(m.memberId)
                      rows.push(m)
                    }
                  })
                }
              }
              if (rows.length === 0) {
                this.desserts = []
              } else {
                if (this.dataItemImport.length > 0) {
                  // console.log('เข้า', this.dataItemImport)
                  // console.log('เข้า', res.data)
                  this.desserts = this.dataItemImport.filter((item) => {
                    return rows.some(
                      (member) => member.memberId === item.memberId
                    ) // กรองเฉพาะ uid ที่อยู่ใน listMember
                  })
                  // console.log('dddddd', this.desserts)
                } else {
                  // console.log('gggg---')

                  this.desserts = rows.map((el) => {
                    this.addGenderOption(el.gender)
                    el.gender =
                      el.gender === 'male'
                        ? 'ชาย'
                        : el.gender === 'female'
                          ? 'หญิง'
                          : 'ไม่ระบุ'
                    el.CONDITION_TERM2 =
                      el.CONDITION_TERM2 === 'True'
                        ? 'รับข่าวสาร'
                        : 'ไม่รับข่าวสาร'
                    el.disabled = el.CONDITION_TERM2 !== 'รับข่าวสาร'
                    if (el.disabled) {
                      this.disabledCount++
                    }

                    if (this.dataLevel) {
                      const level = this.dataLevel.find(
                        (ell) => parseInt(ell.value) === parseInt(el.levelId)
                      )
                      el.LevelName = (level && level.text) || 'ไม่ระบุ'
                    }
                    return el
                  })
                  // console.log('ffffff', this.desserts)
                }
              }
              // สาขานี้ (มีตัวกรอง) ไม่เคยนับใหม่ ต่างจากสาขาไม่มีตัวกรองและ
              // getMember() ที่ตั้งค่าให้ ทำให้กดค้นหาแล้วตัวเลขค้างค่าเดิม
              this.allMember = this.desserts.length
              this.autoSelectAll()
              this.loadingMember = false
            })
            .catch((error) => {
              console.error('Error fetching data:', error)
              this.loadingMember = false
            })
        }
      } catch (error) {
        console.error('Unexpected error:', error)
        this.loadingMember = false
      }
    },
    notSellSql (sql) {
      const out = {}
      NOT_SELL_KEYS.forEach((k) => {
        if (sql[k] !== undefined) out[k] = sql[k]
      })
      out.noBill = true
      return out
    },
    countDataDisable () {
      this.desserts.forEach((item) => {
        if (item.disabled) {
          this.disabledCount += 1
        }
      })
    },
    // ดึงรายชื่อมาใหม่ = ติ๊กทุกคนที่ส่งได้ให้เลย โดนัทจึงนับจำนวนที่จะส่งจริงทันที
    // ไม่ต้องรอให้คนกดติ๊กเอง (ปุ่มค้นหาล้างการติ๊กไว้ก่อนยิง จึงต้องติ๊กคืนที่นี่)
    // ยกเว้นเข้ามาจากปุ่มส่งซ้ำ ซึ่งมีรายชื่อผู้รับเดิมที่ต้องเคารพ
    autoSelectAll () {
      if (this.resendRecipientIds && this.resendRecipientIds.size > 0) {
        return
      }
      this.selected = this.filteredDesserts.filter((item) => !item.disabled)
      this.lengthMember = this.selected.length
    },
    selectAllToggle () {
      let countDisabled = []
      this.filteredDesserts.forEach((item) => {
        if (item.disabled !== true) {
          countDisabled.push(item)

          // this.lengthMember = this.selected.length
        }
      })

      if (this.selected.length === countDisabled.length) {
        // ถ้าจำนวนที่เลือกอยู่ครบแล้วให้ unselect all
        this.selected = []
        this.lengthMember = 0
        // console.log('unselect')
      } else {
        // select ทั้งหมด
        // console.log(this.selected)

        this.selected = countDisabled.slice()
        this.lengthMember = this.selected.length
      }
    },
    toggleItemSelection (item) {
      if (item.disabled) return

      const index = this.selected.findIndex(
        (selectedItem) => selectedItem.memberId === item.memberId
      )
      if (index === -1) {
        // เพิ่มรายการเข้าไปใน selected array
        this.selected.push(item)
        // console.log('this.selected', this.selected)
      } else {
        // ยกเลิกการเลือกและลบรายการออกจาก selected array
        this.selected.splice(index, 1)
      }

      // อัปเดตความยาวของรายการที่เลือก
      this.lengthMember = this.selected.length
    },
    async getMember (ignoreFilter) {
      this.loadingMember = true
      try {
        this.disabledCount = 0

        const res = await axios.get(
          `${this.DNS_IP}/member/get?shopId=${
            this.$session.getAll().data.shopId
          }`
        )
        let rs = res.data
        // console.log('rs', rs)

        if (rs.status === false) {
          this.desserts = []
        } else {
          if (!ignoreFilter) {
            rs = rs.filter((el) => this.matchesMemberFilter(el))
          }
          this.desserts = rs.map((el) => {
            el.gender =
              el.gender === 'male'
                ? 'ชาย'
                : el.gender === 'female'
                  ? 'หญิง'
                  : 'ไม่ระบุ'
            el.CONDITION_TERM2 =
              el.CONDITION_TERM2 === 'True' ? 'รับข่าวสาร' : 'ไม่รับข่าวสาร'
            el.disabled = el.CONDITION_TERM2 !== 'รับข่าวสาร'

            if (this.dataLevel) {
              const level = this.dataLevel.find(
                (ell) => parseInt(ell.value) === parseInt(el.levelId)
              )
              el.LevelName = (level && level.text) || 'ไม่ระบุ'
            }

            return el
          })
          this.allMember = this.desserts.length
          await this.countDataDisable()
          this.autoSelectAll()
        }
        this.loadingMember = false
      } catch (error) {
        console.error('Error fetching members:', error)
        this.loadingMember = false
      }
    },
    inRange (value, range) {
      if (!range || range.length < 2) {
        return true
      }
      const low = parseFloat(range[0])
      const high = parseFloat(range[1])
      if (isNaN(low) || isNaN(high) || high <= 0) {
        return true
      }
      const num = parseFloat(value)
      if (isNaN(num)) {
        return false
      }
      return num >= low && num <= high
    },
    matchesMemberFilter (row) {
      if (this.selectLevel && this.selectLevel.length > 0) {
        const levels = this.selectLevel.map((el) => String(el))
        if (levels.indexOf(String(row.levelId)) === -1) {
          return false
        }
      }
      if (this.selectGender && this.selectGender.length > 0) {
        if (this.selectGender.indexOf(row.gender) === -1) {
          return false
        }
      }
      if (!this.inRange(row.currentPoint, this.scoreRange)) {
        return false
      }
      if (!this.inRange(row.age, this.age)) {
        return false
      }
      return true
    },
    clearTextField () {
      this.date = []
    },
    getColorGender (gender) {
      if (gender === 'ชาย') return '#16B1FF'
      else if (gender === 'หญิง') return '#FF4C51'
      else return '#8A8D93'
    },
    getColorLevel (level) {
      const foundLevel = this.dataLevel.find(
        (el) => parseInt(el.levelId) === parseInt(level.levelId)
      )
      if (foundLevel && foundLevel.color) {
        return foundLevel.color
      }
      return 'blue-grey lighten-1'
    },
    async getLevel () {
      await axios
        .get(
          this.DNS_IP +
            '/level/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.dataLevel = []
          } else {
            this.dataLevel = res.data.map((el) => {
              el.levelId = parseInt(el.levelId)
              el.text = el.name
              el.value = el.levelId
              return el
            })
            // console.log('this.dataLevel', this.dataLevel)
          }
        })
    },
    async getGender () {
      await axios
        .get(
          this.DNS_IP +
            '/level/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.dataLevel = []
          } else {
            this.dataLevel = res.data.map((el) => {
              el.levelId = parseInt(el.levelId)
              el.text = el.name
              el.value = el.levelId
              return el
            })
            // console.log('this.dataLevel', this.dataLevel)
          }
        })
    },
    // ล้าง = กลับไปสภาพเดียวกับตอนเพิ่งเปิดหน้า แล้วดึงรายชื่อชุดเดิมที่ mounted ใช้
    // กดค้นหาต่อจากนี้จึงได้จำนวนเท่ากับ get ครั้งแรก
    clear () {
      // dateRangeText เป็น computed ไม่มี setter การเขียนทับมีแต่ทำให้ Vue เตือน
      this.date = []
      this.selectBranch = []
      this.selectBrand = []
      this.selectCategoryType = []
      this.selectChannel = []
      this.selectGender = []
      this.selectItemGroup = []
      this.selectLevel = []
      this.selectModel = []
      this.minScore = ''
      this.maxScore = ''
      this.minScoreAge = ''
      this.maxScoreAge = ''
      this.desserts = []
      this.scoreRange = [0, 0]
      this.age = [0, 0]
      this.allMember = 0
      this.search = ''
      this.selected = []
      this.lengthMember = 0
      this.page = 1
      // รายชื่อที่นำเข้าจากไฟล์ยังกรองผลค้นหาอยู่ ถ้าไม่ล้างด้วย ค้นหารอบหน้า
      // จะยังถูกจำกัดไว้เท่าไฟล์เดิม ทั้งที่หน้าจอบอกว่าล้างตัวกรองหมดแล้ว
      this.dataItemImport = []
      // เช่นเดียวกับรายชื่อผู้รับเดิมของปุ่มส่งซ้ำ ไม่งั้นติ๊กอัตโนมัติจะถูกข้าม
      this.resendRecipientIds = null
      this.resendApplied = false
      this.getMember(true)
    },
    getDataReward () {
      axios
        .get(
          this.DNS_IP +
            '/reward/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then((res) => {
          this.dataReward = res.data
          // console.log('datareward', res.data)
        })
    },
    getActivity () {
      this.itemsActivity = [] // เริ่มต้น array ให้ว่างเปล่า

      axios
        .get(
          `${this.DNS_IP}/activity/get?shopId=${
            this.$session.getAll().data.shopId
          }&bvpStatusQuestionnaire=True`
        )
        .then((res) => {
          // console.log('itemsActivity', res.data)

          // ปรับเปลี่ยนข้อมูลและตั้งค่าให้กับ itemsActivity
          this.itemsActivity = res.data.map((el) => {
            return {
              ...el, // รวมข้อมูลเดิม
              text: el.title, // เพิ่ม property ใหม่
              value: el.activityId // เพิ่ม property ใหม่
            }
          })
        })
        .catch((error) => {
          console.error('Error fetching activity:', error)
        })
    },
    hasNonEmptyProperties (obj) {
      return Object.values(obj).some((value) => value !== '' && value !== null)
    },

    // Method to execute logic based on contentBroadcast properties
    sent () {},
    stopSendProgress () {
      if (this.sendTimer) {
        clearInterval(this.sendTimer)
        this.sendTimer = null
      }
    },
    finishSend (goReport) {
      this.stopSendProgress()
      this.sentLoad = false
      this.sendPct = 0
      this.sendBroadcastId = null
      if (goReport) {
        this.clear()
        this.clearObj()
        this.$router.push('/Reports/reportBroadcast')
      }
    },
    startSendProgress (id) {
      this.stopSendProgress()
      this.sendBroadcastId = id
      this.sendPct = 0
      this.sendStartedTs = Date.now()
      this.$root.$emit('bpv-progress-start', { id })
      this.sendTimer = setInterval(async () => {
        if (Date.now() - this.sendStartedTs > 15 * 60 * 1000) {
          this.finishSend(true)
          return
        }
        try {
          const res = await axios.get(this.DNS_IP + '/broadcast/progress?id=' + id)
          const d = res.data || {}
          if (!d.status || !d.progress) return
          const p = d.progress
          if (typeof p.pct === 'number') this.sendPct = p.pct
          if (p.done || p.failed || p.stale) {
            this.finishSend(true)
          }
        } catch (err) {
          console.error('broadcast progress', err)
        }
      }, 1000)
    },
    async sentBroadcast () {
      if (this.sentLoad) return
      if (this.selected.length > 0) {
        let contentBroadcast = {
          message: this.message,
          fileImg: this.fileImg,
          img: this.img,
          rewardId: this.rewardId,
          rewardName: this.rewardName,
          rewardImg: this.rewardImg,
          rewardPoint: this.rewardPoint,
          acImg: this.acImg,
          acName: this.acName,
          fileCovers: this.fileCovers,
          fileVDO: null,
          radioGroup: this.radioGroup,
          note: this.note,
          noteReward: this.noteReward,
          covers: this.covers,
          vdo: this.vdo
        }
        // console.log(contentBroadcast)
        if (contentBroadcast.vdo && !contentBroadcast.fileCovers) {
          this.$swal('กรุณาตรวจสอบ', 'กรุณาอัปโหลดภาพหน้าปก', 'error')
        } else if (!contentBroadcast.vdo && contentBroadcast.fileCovers) {
          this.$swal('กรุณาตรวจสอบ', 'กรุณาอัปโหลดวิดีโอ', 'error')
        } else {
          if (this.hasNonEmptyProperties(contentBroadcast)) {
            await this.$swal({
              title: 'บรอดแคสต์ข้อความ',
              // บอกจำนวนผู้รับในคำถาม เพราะตอนนี้รายชื่อถูกติ๊กให้อัตโนมัติ
              // ตั้งแต่ดึงข้อมูลมา คนกดจะได้เห็นว่ากำลังส่งถึงกี่คน
              text: `ข้อความบรอดแคสต์จะถูกส่งไปยัง ${this.lengthMember.toLocaleString()} คนทันที ต้องการดำเนินการต่อหรือไม่`,
              type: 'warning',
              showCancelButton: true,
              cancelButtonColor: '#b3b1ab',
              confirmButtonColor: '#3085d6',
              cancelButtonText: 'ไม่',
              confirmButtonText: 'ใช่'
            }).then(async (res) => {
              this.sentLoad = true
              // add broadcast
              let data = {}

              if (this.message !== '') {
                data.message = this.message
              }
              if (
                this.rewardId !== '' &&
                this.rewardName !== '' &&
                this.rewardImg !== '' &&
                this.rewardPoint !== ''
              ) {
                data.rewardId = this.rewardId
                data.pictureUrl = this.rewardImg
                data.point = this.rewardPoint
                data.name = this.rewardName
                if (this.noteReward !== '') {
                  data.note = this.noteReward
                }
              }
              if (this.acImg !== '' || this.acName !== '') {
                this.selectType = 'กิจกรรม'
                data.pictureUrl = this.acImg
                data.name = this.acName
                if (this.noteAct) {
                  data.note = this.noteAct
                }
              }
              if (this.fileImg !== null && this.fileImg !== '') {
                // console.log('111111')

                const _this = this
                let params = new FormData()
                params.append('file', this.fileImg)

                await axios
                  .post(this.DNS_IP + `/file/upload/blog`, params)
                  .then(async function (response) {
                    _this.picture = response.data
                    // console.log(_this.picture)
                    data.pictureUrl = response.data
                  })
              }
              if (
                this.fileCovers !== null &&
                this.fileCovers !== '' &&
                this.fileVDO !== null &&
                this.fileVDO !== ''
              ) {
                if (this.note !== '') {
                  data.note = this.note
                }
                const _this = this
                let params = new FormData()
                params.append('file', this.fileCovers)
                let paramsVDO = new FormData()
                paramsVDO.append('file', this.fileVDO)
                // console.log('2222222')

                await axios
                  .post(this.DNS_IP + `/file/upload/blog`, params)
                  .then(async function (response) {
                    _this.picture = response.data
                    // console.log(_this.picture)
                    data.pictureUrl = response.data
                  })
                await axios
                  .post(this.DNS_IP + `/file/upload/video`, paramsVDO)
                  .then(async function (response) {
                    _this.videoURL = response.data
                    // console.log('response.data', response.data)

                    data.vdoURL = response.data
                  })
                this.selectType = 'video'
              }

              // เพิ่มค่าที่จำเป็นทั้งหมดลงใน data
              Object.assign(data, {
                shopId: this.$session.getAll().data.shopId,
                module: this.selectType,
                referId: this.selectType === 'reward' ? this.rewardId : this.selectType,
                NumberOfRecipients: this.lengthMember,
                lineUserId: this.selected,
                CREATE_USER: this.$session.getAll().data.userName,
                LAST_USER: this.$session.getAll().data.userName
              })
              // console.log('data', data)
              // เก็บLOGก่อน
              await axios
                .post(this.DNS_IP + '/broadcast/BPV/addLOG', data)
                .then((res) => {
                  // ยิงบอร์ดแคส
                  // console.log('data >>>>', res.data)
                  if (res.data !== '') {
                    data.id = res.data
                    this.startSendProgress(data.id)
                    axios
                      .post(this.DNS_IP + '/broadcast/BPV/add', data)
                      .catch((error) => {
                        console.error('BPV/add', error)
                        this.finishSend(false)
                        this.$swal(
                          'ผิดพลาด',
                          'ไม่สามารถส่งบอร์ดแคสต์ได้ กรุณาทำรายการใหม่อีกครั้ง',
                          'error'
                        )
                      })
                  } else {
                    this.sentLoad = false
                    this.clear()
                    this.clearObj()
                    this.$swal(
                      'กรุณาตรวจสอบ',
                      'ไม่สามารถส่งบอร์ดแคสต์ได้ กรุณาทำรายการใหม่อีกครั้ง',
                      'warning'
                    )
                  }
                })
                .catch((error) => {
                  console.error('addLOG', error)
                  this.$swal(
                    'ผิดพลาด',
                    'ไม่สามารถส่งบอร์ดแคสต์ได้ กรุณาทำรายการใหม่อีกครั้ง',
                    'error'
                  )
                  this.sentLoad = false
                })
              // axios (log) .then({
              //   axios Broadcast
              // $swal  redirec
            })

            // await axios
            //   .post(this.DNS_IP + '/broadcast/add', data)
            //   .then(async (result) => {
            //     console.log('result', result)
            //     if (result.data.status === true) {
            //       // add audience
            //       this.clear()
            //       this.clearObj()
            //       this.sentLoad = false
            //     } else {
            //       this.$swal('ผิดพลาด', 'ไม่สามารถส่งบอร์ดแคสต์ได้', 'error')
            //       this.sentLoad = true
            //     }
            //   })
          } else {
            this.$swal(
              'กรุณาตรวจสอบ',
              'ไม่สามารถส่งบอร์ดแคสต์ได้ กรุณาเลือกรายข้อความ',
              'question'
            )
          }
        }
      } else {
        this.$swal(
          'ไม่สำเร็จ',
          'ไม่สามารถส่งบอร์ดแคสต์ได้ กรุณาเลือกรายชื่อลูกค้า',
          'error'
        )
      }
    },
    addAudience () {
      axios
        .post(this.DNS_IP + '/audiences/add', this.sort)
        .then(async (res) => {})
    },
    async getListMember () {
      try {
        const res = await axios.post(this.DNS_IP + '/hitorysell/get-distinct', {
          shopId: this.$session.getAll().data.shopId
        })
        // console.log('res', res.data)
        this.listMember = res.data // เก็บข้อมูลสมาชิกที่ได้จาก API
      } catch (error) {
        console.error('Error fetching members:', error)
      }
    },
    async uploadFile () {
      this.dialog = false // ปิด dialog
      const input = this.$refs.fileInput // อ้างอิงไปยัง input file

      if (input.files.length === 0) {
        // console.log('กรุณาเลือกไฟล์')
        return
      }

      await this.importData(input.files[0]) // ส่งไฟล์ไปยังฟังก์ชัน importData
    },
    async importData (file) {
      await this.getListMember() // รอให้ข้อมูลสมาชิกถูกดึงมาก่อน
      this.dataItemImport = []

      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])

          const dataByUid = {}
          rowObj.forEach((item) => {
            dataByUid[item.liffUserId] = item
          })

          // กรองข้อมูลตามรายการที่ได้รับจาก getListMember()
          const filteredData = this.listMember.filter((item) => {
            return rowObj.some((uid) => uid.uid === item.liffUserId) // กรองเฉพาะ uid ที่อยู่ใน listMember
          })

          // เก็บค่าที่ได้เข้า this.desserts
          this.desserts = filteredData.map((el) => {
            this.addGenderOption(el.gender)
            el.gender =
              el.gender === 'male'
                ? 'ชาย'
                : el.gender === 'female'
                  ? 'หญิง'
                  : 'ไม่ระบุ'
            el.CONDITION_TERM2 =
              el.CONDITION_TERM2 === 'True' ? 'รับข่าวสาร' : 'ไม่รับข่าวสาร'
            el.disabled = el.CONDITION_TERM2 !== 'รับข่าวสาร'
            if (el.disabled) {
              this.disabledCount++
            }

            if (this.dataLevel) {
              const level = this.dataLevel.find(
                (ell) => parseInt(ell.value) === parseInt(el.levelId)
              )
              el.LevelName = (level && level.text) || 'ไม่ระบุ'
            }
            return el
          })
          this.dataItemImport = this.desserts
        })
      }

      reader.readAsBinaryString(file) // เริ่มอ่านไฟล์
    },
    clearObj () {
      this.message = ''
      this.fileImg = ''
      this.img = ''
      this.rewardName = ''
      this.rewardImg = ''
      this.rewardPoint = ''
      this.acImg = ''
      this.acName = ''
      this.fileCovers = ''
      this.fileVDO = null
      this.radioGroup = ''
      this.note = ''
      this.noteReward = ''
      this.noteAct = ''
      this.covers = ''
      this.vdo = ''
      this.lengthMember = 0
      this.disabledCount = 0
      this.selected = []
    },
    clearContent () {
      this.message = ''
      this.fileImg = ''
      this.img = ''
      this.rewardName = ''
      this.rewardImg = ''
      this.rewardPoint = ''
      this.acImg = ''
      this.acName = ''
      this.fileCovers = ''
      this.fileVDO = null
      this.radioGroup = ''
      this.note = ''
      this.noteReward = ''
      this.noteAct = ''
      this.covers = ''
      this.vdo = ''
    }
  }
}
</script>

<style scoped>
.broadcast-btn {
  position: relative;
  overflow: hidden;
}
.broadcast-btn__fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.32);
  transition: width 0.4s ease;
}
.broadcast-btn__loader {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.title {
  height: 60px;
  width: 100%;
  padding-top: 20px;
}

.content {
  height: 1190px;
  width: 100%;
}

.content-top {
  height: 840px;
  display: flex;
  justify-content: space-between;
}

.content-condition {
  width: 430px;
  height: 860px;
}

.progress-cycle {
  height: 307px;

  width: 100%;
  /* margin-bottom: 20px; */
}

.conditions {
  height: calc(100% - 307px);

  width: 100%;
}

.line {
  display: flex;
  justify-content: center;
  align-items: center;
  /* สีพื้นหลังของเส้นแบ่ง */
  width: 5px;
  height: 800px;
  padding: 12px 0;
}

.content-data-member {
  width: calc(100% - 460px - 10px);
  /* หักลบความกว้างของ content-condition และ line */
  height: 860px;
}

.content-bottom {
  height: 300px;
  width: 100%;
}

.sub-head {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.cycle {
  display: flex;
  justify-content: center;
  align-content: center;
}

.point {
  display: flex;
}

.setPadding {
  padding: 12px 15px 0;
}

.v-simple-checkbox .v-icon {
  color: #000 !important;
}
.v-textarea__details {
  display: flex; /* จัดเรียงแบบ Flexbox */
  justify-content: flex-start; /* ขยับตัวนับไปด้านขวา */
}

.v-btn.active {
  background-color: #f5f5f5 !important; /* สีพื้นหลังเมื่อปุ่ม active */
  color: #404c59 !important; /* สีข้อความเมื่อปุ่ม active */
}

::v-deep .custom-counter .v-counter {
  justify-content: flex-start !important; /* จัดตำแหน่งให้อยู่ทางซ้าย */
}

.text-ellipsis {
  white-space: nowrap; /* ไม่ให้มีการตัดบรรทัด */
  overflow: hidden; /* ซ่อนส่วนที่เกินขอบ */
  text-overflow: ellipsis; /* แสดง ... */
}
.text-ellipsis {
  width: 100%; /* ตั้งความกว้าง */
  display: block; /* ให้แสดงเป็นบล็อกเพื่อควบคุมการแสดงผล */
  white-space: nowrap; /* ไม่ให้มีการตัดบรรทัด */
  overflow: hidden; /* ซ่อนข้อความส่วนที่เกิน */
  text-overflow: ellipsis; /* แสดง ... เมื่อข้อความเกิน */
}
.radio-group {
  display: flex;
  justify-content: flex-end;
  /* เพิ่ม style อื่นๆ ถ้าจำเป็น */
}
.custom-height .v-input__control {
  height: 40px !important;
}
::v-deep .v-select.custom-height .v-input__control {
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BroadCast/Audience.vue